import { theme as capturiTheme } from '@capturi/ui-theme'
import { extendTheme } from '@chakra-ui/react'

export const theme = extendTheme(capturiTheme, {
  colors: {
    primary: {
      '50': '#efebf1',
      '100': '#cec1d4',
      '200': '#b7a3c0',
      '300': '#967aa3',
      '400': '#816091',
      '500': '#623875',
      '600': '#59336a',
      '700': '#462853',
      '800': '#361f40',
      '900': '#291831',
    },
  },
  components: {
    ...capturiTheme.components,
    Alert: {
      ...capturiTheme.components.Alert,
      variants: {
        ...capturiTheme.components.Alert.variants,
        'left-accent': {
          ...capturiTheme.components.Alert.variants['left-accent'],
          container: {
            ...capturiTheme.components.Alert.variants['left-accent'].container,
            borderInlineStartColor: 'signal.caution',
          },
          icon: {
            ...capturiTheme.components.Alert.variants['left-accent'].icon,
            color: 'signal.cautionDark',
          },
        },
      },
    },
  },
})
